import {Loader} from "@googlemaps/js-api-loader";

import {waitFor} from "./helpers/waitFor";

if (document.querySelector('.footer-map')) {
    const themePath = wp_environment.template_directory_uri;
    const iconPath = themePath + '/assets/graphics';
    const markerIcon = iconPath + '/marker.png';


    const createMap = async () => {
        let head = document.getElementsByTagName('head')[0];

// Save the original method
        let insertBefore = head.insertBefore;

// Replace it!
        head.insertBefore = function (newElement, referenceElement) {

            if (newElement.href && newElement.href.indexOf('//fonts.googleapis.com/css?family=Roboto') > -1) {

                // console.info('Prevented Roboto from loading!');
                return;
            }

            insertBefore.call(head, newElement, referenceElement);
        };

        let lat = parseFloat(wp_environment.option_lat);
        let lng = parseFloat(wp_environment.option_lng);


        loader.load().then(() => {


            const location = {lat: lat, lng: lng};
            const map = new google.maps.Map(document.getElementById('map'), {
                zoom: 16,
                center: location,
                disableDefaultUI: false,
                styles: [
                    {
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#616161"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#bdbdbd"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#eeeeee"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#757575"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.medical",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": `${wp_environment.map_color}`
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e5e5e5"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#757575"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#dadada"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#616161"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.line",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e5e5e5"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.station",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#eeeeee"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#c9c9c9"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    }
                ]
            });

            let marker = new google.maps.Marker({
                map: map,
                icon: markerIcon,
                draggable: false,
                animation: google.maps.Animation.DROP,
                position: {lat: lat, lng: lng}
            });


        });
    }
    const key = wp_environment.google_api_key;
    const loader = new Loader({apiKey: key});
    const theMapContainer = document.getElementById('map')
    const replacementImage = document.querySelector('.ume-map-replacement-image');
    const isDev = window.location.href.includes('meap.local') ? true : false;
    if (window.hasOwnProperty('__cmp') && typeof __cmp !== 'undefined') {
        function getStatus(e, o) {
            let x = __cmp('getCMPData');
            if ("vendorConsents" in x) {
                if ("s1104" in x.vendorConsents && x.vendorConsents["s1104"]) {
                    if (replacementImage !== null) {
                        replacementImage.classList.add('d-none');
                    }
                    //createMap();
                    theMapContainer.setAttribute('data-consent-given', 'given');
                } else {
                    if (replacementImage !== null) {
                        replacementImage.classList.remove('d-none');
                        if (replacementImage.getAttribute('data-src') !== undefined) {
                            replacementImage.src = replacementImage.getAttribute('data-src');
                        }

                    }
                    theMapContainer.replaceChildren();
                    theMapContainer.setAttribute('data-consent-given', '');
                }
            }
        }

        if (document.getElementById('map')) {
            __cmp('addEventListener', ['consent', getStatus, false], null);
        }

    }

    document.onreadystatechange = async () => {
        if (document.readyState === 'complete') {
            const checkForCMP = () => {
                if (isDev) {
                    return true;
                }

                if (window.hasOwnProperty('__cmp') && typeof __cmp !== 'undefined') {
                    if (__cmp('consentStatus') !== null && __cmp('consentStatus').consentExists) {
                        return true
                    }
                }

                return false;
            }

            // polyfill if not supported
            if (!('IntersectionObserver' in window) ||
                !('IntersectionObserverEntry' in window) ||
                !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
                if (theMapContainer.getAttribute('data-consent-given') === 'given' || isDev) {
                    createMap();
                }

            } else {
                const mapContainer = document.querySelectorAll('.footer-map');
                const mapObserver = new IntersectionObserver((entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            if (theMapContainer.getAttribute('data-consent-given') === 'given' || isDev) {
                                createMap();
                            }
                            mapObserver.unobserve(entry.target);
                        }
                    });

                }, {rootMargin: '400px'});
                try {
                    await waitFor(checkForCMP, 3000);

                    mapContainer.forEach(con => {
                        mapObserver.observe(con);
                    })


                } catch (err) {
                    console.error('consent status not loaded')
                }


            }


        }
    };
}




